/**
 * CoLab Website - Main App Entry Point
 * Vite + Laravel version
 */

// Import Bootstrap якщо потрібен
// import * as bootstrap from 'bootstrap';

// Import модулів (конвертуй свої файли з app/js/paths у модулі)
import { Header } from './modules/header';
import { MobileMenu } from './modules/mobile-menu';
import { MegaMenu } from './modules/mega-menu';
import { ButtonEffects } from './modules/button-effects';
import { HeroParallax } from './modules/hero-parallax';
import { Video } from './modules/video';
import { Services } from './modules/services';
import { Stacking } from './modules/stacking';
import { News } from './modules/news';
import { Map } from './modules/map';
import { Form } from './modules/form';
import { Animations } from './modules/animations';
import { Lang } from './modules/lang';
import { Search } from './modules/search';
import { LazyLoad } from './modules/lazy-load';
import { Gallery } from './modules/gallery';
import { Vacancies } from './modules/vacancies';

// Import Canvas (якщо потрібен)
import './modules/canvas';

console.log('[CoLab] App initializing...');

// DOM Ready
document.addEventListener('DOMContentLoaded', () => {
    console.log('[CoLab] DOM ready, starting modules...');

    // ========================================
    // Header & Navigation
    // ========================================
    LazyLoad.init();
    Header.init();
    console.log('[CoLab] Header initialized');

    MobileMenu.init();
    console.log('[CoLab] MobileMenu initialized');

    MegaMenu.init();
    console.log('[CoLab] MegaMenu initialized');

    ButtonEffects.init();
    console.log('[CoLab] ButtonEffects initialized');

    // ========================================
    // Hero Section
    // ========================================
    HeroParallax.init({
        startX: 120,
        endX: -50,
        fadeOut: true,
        fadeStart: 1,
        fadeEnd: 1,
        smoothing: 0.05
    });
    console.log('[CoLab] HeroParallax initialized');

    // ========================================
    // Video Section
    // ========================================
    Video.init();
    console.log('[CoLab] Video initialized');

    // ========================================
    // Services Section
    // ========================================
    Services.init();
    console.log('[CoLab] Services initialized');

    Stacking.init();
    console.log('[CoLab] Stacking initialized');

    // ========================================
    // Gallery
    // ========================================
    if (document.querySelector('.gallery')) {
        Gallery.init();
        console.log('[CoLab] Gallery initialized');
    }

    // ========================================
    // Vacancies
    // ========================================
    if (document.querySelector('.vacancy-item')) {
        Vacancies.init();
        console.log('[CoLab] Vacancies initialized');
    }

    // ========================================
    // News Slider
    // ========================================
    News.init({
        loop: true,
        autoplay: 5000,
        pauseOnHover: true,
        speed: 600,
        gap: 12,
        useJsGap: true,
        breakpoints: {
            0: { slidesPerView: 1, slideWidth: 'auto' },
            576: { slidesPerView: 1.2, slideWidth: 'auto' },
            768: { slidesPerView: 1.5, slideWidth: 'auto' },
            992: { slidesPerView: 'auto', slideWidth: 480 },
            1200: { slidesPerView: 'auto', slideWidth: 520 }
        }
    });
    console.log('[CoLab] News initialized');

    // ========================================
    // Map
    // ========================================
    Map.init();
    console.log('[CoLab] Map initialized');

    // ========================================
    // Form
    // ========================================
    Form.init();
    console.log('[CoLab] Form initialized');

    // ========================================
    // Animations
    // ========================================
    Animations.init();
    console.log('[CoLab] Animations initialized');

    // ========================================
    // Language Selector
    // ========================================
    Lang.init();
    console.log('[CoLab] Lang initialized');

    // ========================================
    // Search
    // ========================================
    Search.init();
    console.log('[CoLab] Search initialized');

    console.log('[CoLab] All modules initialized!');
});
